/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { ComponentChildren } from 'preact';
import { classNames } from '../utils/UNSAFE_classNames';
import { messageHeaderStyles } from './themes/MessageStyles.css';
import { MessageVariant } from './Message.types';

/**
 * Props for the MessageHeader component
 */
type MessageHeaderProps = {
  variant?: MessageVariant;
  children?: ComponentChildren;
};
/**
 * A component that styles the header for the message component
 * @param param0 Props
 * @returns MessageHeader component instance
 */
export function MessageHeader({ children, variant = 'banner' }: MessageHeaderProps) {
  const rootClasses = classNames([messageHeaderStyles.base, messageHeaderStyles[variant]]);
  return (
    <div role="presentation" class={rootClasses}>
      {children}
    </div>
  );
}
